import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import filterSortSupportedProducts from '../../helpers/filterSortSupportedProducts';
import accountPositionSubscriptionService from '../../services/subscriptions/accountPositionSubscriptionService';
export var REQUEST_ACCOUNT_POSITIONS = 'REQUEST_ACCOUNT_POSITIONS';
export var RECEIVE_ACCOUNT_POSITIONS = 'RECEIVE_ACCOUNT_POSITIONS';
export var RECEIVE_POSITION_EVENT = 'RECEIVE_POSITION_EVENT';
export var SELECT_POSITION = 'SELECT_POSITION';
export var getAccountPositions = function getAccountPositions(params) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var positions, filteredSortedPositions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestingAccountPositions);
              _context.next = 3;
              return dispatch(callAPI('GetAccountPositions', params));
            case 3:
              positions = _context.sent;
              if (!(positions instanceof Array)) {
                _context.next = 10;
                break;
              }
              filteredSortedPositions = filterSortSupportedProducts(positions);
              dispatch(receiveAccountPositions({
                AccountId: params.accountId,
                data: filteredSortedPositions
              }));
              return _context.abrupt('return', filteredSortedPositions);
            case 10:
              console.log(positions);
            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var subscribeToAccountPositionEvents = function subscribeToAccountPositionEvents(AccountId) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : receivePositionsEvent;
  return function (dispatch) {
    accountPositionSubscriptionService.subscribe(function (update) {
      if (update.AccountId === AccountId) {
        dispatch(callback(update));
      }
    });
  };
};
export var receivePositionsEvent = function receivePositionsEvent(payload) {
  return {
    type: RECEIVE_POSITION_EVENT,
    payload: payload
  };
};
export var requestingAccountPositions = {
  type: REQUEST_ACCOUNT_POSITIONS,
  payload: {}
};
export var receiveAccountPositions = function receiveAccountPositions(payload) {
  return {
    type: RECEIVE_ACCOUNT_POSITIONS,
    payload: payload
  };
};
export var selectPositionAndSave = function selectPositionAndSave(payload) {
  return function (dispatch) {
    localStorage.setItem('selectedPositionId', payload);
    dispatch(selectPosition(payload));
  };
};
export var selectPosition = function selectPosition(payload) {
  return {
    type: SELECT_POSITION,
    payload: payload
  };
};